import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useGlobalContext from '../../../../hooks/useGlobalContext';
import ErrorMessage from '../../../../components/common/ErrorMessage';
import localize from '../../../../common/localize';
import LoadingPanel from '../../../../components/common/LoadingPanel';

export default function EvidenceImageViewer() {
  const { DYNAMIC_FORM_FIELD_VALUE_ENDPOINT, config } = useGlobalContext();
  const { valueId, original, rotateImage } = useParams();
  const [showEvidenceViewer, setShowEvidenceViewer] = useState(false);
  const [evidenceUrl, setEvidenceUrl] = useState(undefined);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const needToRotateImage = () => rotateImage === 'true';

  useEffect(() => {
    if (evidenceUrl) {
      setShowEvidenceViewer(true);
    }
  }, [evidenceUrl]);

  useEffect(() => {
    return () => {
      if (evidenceUrl) URL.revokeObjectURL(evidenceUrl);
    };
  }, [evidenceUrl]);

  useEffect(() => {
    if (valueId > 0) {
      downloadEvidence();
    }
  }, [valueId]);

  const downloadEvidence = async () => {
    await axios({
      ...config,
      method: 'get',
      responseType: 'blob', // Force to receive data in a Blob Format
      url: `${DYNAMIC_FORM_FIELD_VALUE_ENDPOINT}/field/${valueId}/download/${original}`,
    })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: 'application/octet-stream',
        });

        const urlBlob = URL.createObjectURL(blob);
        setEvidenceUrl(urlBlob);
      })
      .catch((error) => {
        setErrorMessage(error.message);
        setShowErrorModal(true);
      });
  };

  return (
    <>
      {showErrorModal && (
        <ErrorMessage
          message={errorMessage}
          title={localize.error_unexpected}
          showModal={showErrorModal}
          setShowModal={setShowErrorModal}
        />
      )}
      {showEvidenceViewer ? (
        <div
          style={{
            width: '100%',
            heigth: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            className={needToRotateImage() ? 'rotate_image_to_270_degrees' : ''}
            src={evidenceUrl}
            alt={localize.evidence}
            style={{
              width: needToRotateImage() ? '200px' : '40%',
              height: needToRotateImage() ? '400px' : '60%',
            }}
          />
        </div>
      ) : (
        <div>
          <LoadingPanel />
        </div>
      )}
    </>
  );
}
